import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductoComponent } from './producto/producto.component';
import { ListaPreciosComponent } from './lista-precios/lista-precios.component';
import { InventarioComponent } from './inventario/inventario.component';
import { MovimientosComponent } from './movimientos/movimientos.component';
import { MovimientosAdmComponent } from './movimientos-adm/movimientos-adm.component';

const routes: Routes = [
  {
    path: '', children: [
      { path: "producto/:edit/approved", component: ProductoComponent },
      { path: 'lista_de_precios', component: ListaPreciosComponent },
      { path: "inventario", component: InventarioComponent },
      { path: "movimiento", component: MovimientosComponent },
      { path: "movimiento_administrativo", component: MovimientosAdmComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SkuRoutingModule { }
